import React from "react";
import Grid from "@material-ui/core/Grid";

import { Orientation } from "../constants";
import { OrientationOption } from "../OrientationOption";
import { useCardOrientation } from "../useCardOrientation";
import { withStyles, Styles } from "./styles";

const options = [Orientation.Vertical, Orientation.Horizontal];

const BaseCardOrientation: React.FC<Styles> = ({ classes }) => {
  const currentCardOrientation = useCardOrientation();
  return (
    <Grid container={true} spacing={8} component="ul" className={classes.ul}>
      {options.map(orientationOption => (
        <Grid item={true} key={orientationOption} component="li" className={classes.li}>
          <OrientationOption
            orientation={orientationOption}
            isSelected={currentCardOrientation === orientationOption}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export const CardOrientation = withStyles(BaseCardOrientation);
